module.exports = __webpack_public_path__ + "static/media/charlesPilot19.333fee26.png";